import * as React from 'react';
import { Modal } from '@mitchell/react.component.ux';
import { TranslationService } from "../../../common";
import { IntelligentAssignmentSummary } from '../../constants';
import { StyledDeleteModalBody, StyledDeleteModalIcon, StyledDeleteModalMessage } from './IntelligentAssignmentSummaryComponent.style';
export const IntelligentAssignmentSummaryDeleteModalComponent = ({ isOpen, onConfirmDelete, onCancelDelete }) => {
    const translateFn = TranslationService.translate;
    const confirmButton = {
        id: IntelligentAssignmentSummary.ID_ASSIGNMENT_SUMMARY_DELETE_MODAL_YES_BUTTON,
        label: translateFn(IntelligentAssignmentSummary.DELETE_MODAL_YES_LABEL),
        onClick: onConfirmDelete
    };
    const cancelButton = {
        id: IntelligentAssignmentSummary.ID_ASSIGNMENT_SUMMARY_DELETE_MODAL_NO_BUTTON,
        label: translateFn(IntelligentAssignmentSummary.DELETE_MODAL_NO_LABEL),
        onClick: onCancelDelete
    };
    return (React.createElement(Modal, { id: IntelligentAssignmentSummary.ID_ASSIGNMENT_SUMMARY_DELETE_MODAL, isOpen: isOpen, title: translateFn(IntelligentAssignmentSummary.ASSIGNMENT_SUMMARY_DELETE_MODAL_TITLE), isLightbox: false, maxWidth: "xs", primaryBtn: confirmButton, tertiaryBtn: cancelButton, shouldHideScroll: true, onClose: onCancelDelete },
        React.createElement(StyledDeleteModalBody, null,
            React.createElement(StyledDeleteModalIcon, { className: IntelligentAssignmentSummary.MI_ICON_ALERT_FILLED_TRIANGLE }),
            React.createElement(StyledDeleteModalMessage, null, translateFn(IntelligentAssignmentSummary.ASSIGNMENT_SUMMARY_DELETE_MODAL_CONTENT)))));
};
//# sourceMappingURL=IntelligentAssignmentSummaryDeleteModalComponent.js.map